'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dataObject = require('./data-object');

var _dataObject2 = _interopRequireDefault(_dataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Product = function (_DataObject) {
    (0, _inherits3.default)(Product, _DataObject);
    (0, _createClass3.default)(Product, null, [{
        key: 'ID',
        get: function get() {
            return 'id';
        }
    }, {
        key: 'NAME',
        get: function get() {
            return 'name';
        }
    }, {
        key: 'CATEGORY',
        get: function get() {
            return 'category';
        }
    }, {
        key: 'BRAND',
        get: function get() {
            return 'brand';
        }
    }, {
        key: 'VARIANT',
        get: function get() {
            return 'variant';
        }
    }, {
        key: 'LIST',
        get: function get() {
            return 'list';
        }
    }, {
        key: 'POSITION',
        get: function get() {
            return 'position';
        }
    }, {
        key: 'PRICE',
        get: function get() {
            return 'price';
        }
    }, {
        key: 'QUANTITY',
        get: function get() {
            return 'quantity';
        }
    }, {
        key: 'COUPON',
        get: function get() {
            return 'coupon';
        }
    }, {
        key: 'STOCK',
        get: function get() {
            return 'stock';
        }
    }, {
        key: 'SIZE',
        get: function get() {
            return 'size';
        }
    }, {
        key: 'COLOR',
        get: function get() {
            return 'color';
        }
    }]);

    function Product(fields, additionalRequiredFields, keyMap) {
        var _ret;

        var keepExtraFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        (0, _classCallCheck3.default)(this, Product);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Product.__proto__ || (0, _getPrototypeOf2.default)(Product)).call(this, [Product.ID, Product.NAME], [Product.CATEGORY, Product.BRAND, Product.VARIANT, Product.LIST, Product.POSITION, Product.PRICE, Product.QUANTITY, Product.COUPON, Product.STOCK, Product.SIZE, Product.COLOR], fields, keepExtraFields));

        _this.sanitizeMoney(Product.PRICE);

        _this.isValid(additionalRequiredFields, keyMap);

        return _ret = _this.build(keyMap), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return Product;
}(_dataObject2.default); /* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

exports.default = Product;


//////////////////
// WEBPACK FOOTER
// ./~/progressive-web-sdk/dist/analytics/data-objects/product.js
// module id = 56
// module chunks = 0